import axios from 'axios';

export {
  INITIAL_OTA_STATE,
  getOtaProgressMessage,
  isOtaEventForDevice,
  reduceOtaState,
  shouldHandleOtaEvent,
} from './otaUpdateHelpers';

export async function startOtaUpdate({
  deviceId,
  sketchCode,
  board,
  token,
  onAccepted,
}) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL || ''}/api/devices/${deviceId}/ota-update`,
    { sketchCode, board },
    { headers: { Authorization: `Bearer ${token}` } },
  );

  onAccepted?.(response.data);
  return response.data;
}